import * as React                                    from "react"
import { CardModal, CardModalType, CardModalNotOkButton } from "../../modal"

export default class AddDemographyModal
extends React.Component<AddDemographyModalProps> {
	render() {
		const onClickAddDemographyModalCloseButton  = this.props.onClickCloseButton
		const onClickAddDemographyModalFooterButton = this.props.onClickFooterButton
		const onSubmitAddDemographyModal            = this.props.onSubmit
		const submitting                            = this.props.submitting
		const maxYear                               = this.props.maxYear
		const errors                                = this.props.errors

		return (
			<CardModal active
			           loading={submitting}
			           onClickCloseButton={onClickAddDemographyModalCloseButton}
			           onClickFooterButton={onClickAddDemographyModalFooterButton}
			           onSubmit={onSubmitAddDemographyModal}
			           title="Ajouter une démographie"
			           type={CardModalType.ValidCancel}>
				<div className="columns is-mobile">
					<div className="column field">
						<label className="label" htmlFor={Names.YEAR}>Année</label>
						<p className={`control has-icons-left ${submitting ? "is-loading" : ""}`}>
							<input className={`input ${errors.year ? "is-danger": ""}`}
							       disabled={submitting}
							       id={Names.YEAR}
							       name={Names.YEAR}
							       max={maxYear}
							       min={0}
							       required
							       type="number" />
							<span className="icon is-left">
								<i className="fas fa-calendar" />
							</span>
						</p>
						{errors && errors.year && <p className="help is-danger">{errors.year}</p>}
					</div>
					<div className="column field">
						<label className="label" htmlFor={Names.POPULATION}>Population</label>
						<p className={`control has-icons-left ${submitting ? "is-loading" : ""}`}>
							<input className={`input ${errors.population ? "is-danger": ""}`}
							       disabled={submitting}
							       id={Names.POPULATION}
							       name={Names.POPULATION}
							       min={0}
							       required
							       type="number" />
							<span className="icon is-left">
								<i className="fas fa-users" />
							</span>
						</p>
						{errors && errors.population && <p className="help is-danger">{errors.population}</p>}
					</div>
				</div>
			</CardModal>
		)
	}
}

export namespace Names {
	export const POPULATION = "population"
	export const YEAR       = "year"
}

export interface AddDemographyModalProps {
	errors?            : AddDemographyErrors
	onClickCloseButton : (event: React.SyntheticEvent<Element>) => void
	onClickFooterButton: (button: CardModalNotOkButton ,event: React.SyntheticEvent<Element>) => void
	onSubmit           : (event: React.SyntheticEvent<Element>) => void
	submitting         : boolean
	maxYear            : number
}

export interface AddDemographyErrors {
	year?      : string
	population?: string
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/add-demography-modal.tsx